import { MemberModel } from "./member.model";

export class CallModel extends MemberModel {

    /**
     * å°è¦å¤æ¥/ææ·æèå¶ä»è¡çºçé»è©±èç¢¼
     */
    phoneNumber : string 

}